// src/pages/categories/EditCategory.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCategory from "../../components/categories/FormAddEditCategory";
import useGetCategory from "../../hooks/categories/useGetCategory";
import LoadingPage from "../../components/global/LoadingPage";

const EditCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, category } = useGetCategory(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/categories");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCategory
                isEdit={true}
                currentData={category}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditCategory;
